import { useTranslation } from "gatsby-plugin-react-i18next";
import React, { useEffect, useState } from "react";

import "./TOSWheel.css";

const STEP_COUNT = 5;
const STEP_INTERVAL = 3_000; // 3 seconds

const ORDER = [
  "tenders",
  "fleet-depots",
  "territory",
  "follow-operations",
  "compliance-billing",
  "performance-analysis",
];

const rotate = [{ transform: "rotate(0deg)" }, { transform: "rotate(720deg)" }];
const appear = [{ opacity: 0 }, { opacity: 1 }];
const disappear = [{ opacity: 1 }, { opacity: 0 }];
const duration = duration => ({ fill: "both", duration: duration });

const wheelAnimation = [
  () => {
    document
      .querySelectorAll(
        `
      .tos-wheel-screen path,
      .tos-wheel-connector,
      .tos-wheel-label-line,
      #tos-wheel-hexagon,
      #tos-wheel-dotted-inner-rubber-ring,
      .tos-wheel-dot,
      .tos-wheel-label`
      )
      .forEach(element => {
        element.style.opacity = 0;
      });

    document
      .getElementById("tos-wheel")
      .animate(rotate, { fill: "both", duration: 2_800, easing: "ease-in-out" });

    let delay = 1_000;
    ORDER.map(name => `tos-wheel-dot-${name}`).forEach(id => {
      const dot = document.getElementById(id);
      setTimeout(() => {
        dot.animate(appear, duration(1_000));
      }, delay);
      delay = delay + 200;
    });
  },
  () => {
    document
      .getElementById("tos-wheel-initial-inner-rubber-ring")
      .animate(disappear, duration(2_000));
    document.getElementById("tos-wheel-dotted-inner-rubber-ring").animate(appear, duration(2_000));

    setTimeout(() => {
      const hexagon = document.getElementById("tos-wheel-hexagon");
      hexagon.animate([{ strokeDasharray: "550" }, { strokeDasharray: "550" }], duration(0));
      hexagon.style.dashoffset = 550;
      hexagon.style.opacity = 1;
      hexagon.animate([{ opacity: 1 }, { opacity: 1 }], duration(0));
      hexagon.animate([{ strokeDashoffset: 550 }, { strokeDashoffset: 0 }], duration(2_000));
    }, 250);

    let delay = 250;
    ORDER.map(name => `tos-wheel-connector-${name}`).forEach(id => {
      const connector = document.getElementById(id);
      setTimeout(() => {
        connector.animate(appear, duration(1_500));
      }, delay);
      delay = delay + 300;
    });
  },
  () => {
    document.getElementById("tos-wheel-initial-medium-ring").animate(disappear, duration(2_000));

    let delay = 500;
    ORDER.map(name => `tos-wheel-big-screen-${name}`).forEach(id => {
      const screen = document.getElementById(id);
      setTimeout(() => {
        screen.animate(appear, duration(1_500));
      }, delay);
      delay = delay + 300;
    });

    delay = 1_600;
    ORDER.map(name => `tos-wheel-medium-screen-${name}`).forEach(id => {
      const screen = document.getElementById(id);
      setTimeout(() => {
        screen.animate(appear, duration(750));
      }, delay);
      delay = delay + 300;
    });

    delay = 2_150;
    ORDER.map(name => `tos-wheel-little-screen-${name}`).forEach(id => {
      const screen = document.getElementById(id);
      setTimeout(() => {
        screen.animate(appear, duration(750));
      }, delay);
      delay = delay + 300;
    });
  },
  () => {
    const hexagon = document.getElementById("tos-wheel-hexagon");
    hexagon.animate(
      [
        { opacity: 1, strokeDasharray: "550" },
        { opacity: 0, strokeDasharray: "550" },
        { opacity: 0, strokeDasharray: hexagon.getAttribute("stroke-dasharray") },
        { opacity: 1, strokeDasharray: hexagon.getAttribute("stroke-dasharray") },
      ],
      duration(400)
    );

    let delay = 200;
    ORDER.map(name => `tos-wheel-label-line-${name}`).forEach(id => {
      const labelLine = document.getElementById(id);
      setTimeout(() => {
        labelLine.animate(appear, duration(1_500));
      }, delay);
      delay = delay + 300;
    });

    delay = 400;
    ORDER.map(name => `tos-wheel-label-${name}`).forEach(id => {
      const labelLine = document.getElementById(id);
      setTimeout(() => {
        labelLine.animate(appear, duration(1_500));
      }, delay);
      delay = delay + 300;
    });
  },
];

const resetAnimation = () => {
  document
    .querySelectorAll(
      `.tos-wheel-screen path,
      .tos-wheel-connector,
      .tos-wheel-label-line,
      #tos-wheel-hexagon,
      #tos-wheel-dotted-inner-rubber-ring,
      .tos-wheel-dot,
      .tos-wheel-label`
    )
    .forEach(element => element.animate(disappear, duration(800)));

  document.getElementById("tos-wheel-initial-inner-rubber-ring").animate(appear, duration(800));

  document.getElementById("tos-wheel-initial-medium-ring").animate(appear, duration(800));
};

export default function TOSWheel() {
  const { t } = useTranslation();
  const [stepNumber, setStepNumber] = useState(1);

  useEffect(() => {
    let timeOut = null;

    const step = () => {
      setStepNumber(stepNumber => {
        timeOut = setTimeout(() => {
          step();
        }, STEP_INTERVAL);

        if (stepNumber < STEP_COUNT) {
          wheelAnimation[stepNumber - 1]();
          return stepNumber + 1;
        } else if (stepNumber === STEP_COUNT) {
          return stepNumber + 1;
        } else {
          return stepNumber;
        }
      });
    };

    step();

    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  const restartAnimation = () => {
    setStepNumber(7);
    resetAnimation();
    setTimeout(() => {
      setStepNumber(1);
    }, 800);
  };

  return (
    <div id="tos-wheel-wrapper" className={`tos-animation-step-${stepNumber}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="589"
        height="589"
        viewBox="0 0 589 589"
        id="tos-wheel-svg">
        <g id="tos-wheel-with-labels" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g id="tos-wheel">
            <circle
              id="tos-wheel-core-ring"
              cx="294.5"
              cy="294.5"
              r="52.799"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              id="tos-wheel-inner-ring"
              cx="294.5"
              cy="294.5"
              r="126.717"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              id="tos-wheel-initial-medium-ring"
              cx="294.5"
              cy="294.5"
              r="177"
              stroke="#06C"
              strokeWidth="0.523"></circle>
            <path
              id="tos-wheel-initial-inner-rubber-ring"
              stroke="#288CFF"
              strokeWidth="1"
              d="M294 564c149.117 0 270-120.883 270-270 0-149.117-120.883-270-270-270C144.883 24 24 144.883 24 294c0 149.117 120.883 270 270 270z"></path>
            <path
              id="tos-wheel-dotted-inner-rubber-ring"
              stroke="#288CFF"
              strokeDasharray="1.915 3.83"
              strokeLinejoin="round"
              strokeWidth="1"
              d="M294 564c149.117 0 270-120.883 270-270 0-149.117-120.883-270-270-270C144.883 24 24 144.883 24 294c0 149.117 120.883 270 270 270z"></path>
            <path
              id="tos-wheel-outer-rubber-ring"
              stroke="#003E7C"
              strokeWidth="0.523"
              d="M517.951 459.29c.82-1.12 1.6-2.274 2.392-3.393l5.812 3.352c3.638 2.11 8.278.855 10.385-2.789l19.571-33.927c2.087-3.65.847-8.292-2.791-10.395l-5.731-3.318c.583-1.269 1.165-2.524 1.72-3.793l6.274 2.029c3.976 1.302 8.264-.882 9.565-4.886l12.092-37.265a7.614 7.614 0 00-4.884-9.588l-6.233-2.029c.292-1.364.65-2.707.929-4.078l6.455.679c4.18.44 7.913-2.6 8.36-6.772l4.092-38.969c.433-4.186-2.595-7.932-6.761-8.366l-6.537-.679c0-.712.054-1.39.054-2.103 0-.692-.054-1.384-.054-2.09l6.537-.678a7.618 7.618 0 006.76-8.367l-4.091-38.975c-.434-4.173-4.18-7.206-8.346-6.786l-6.47.7c-.277-1.371-.636-2.722-.928-4.079l6.233-2.042c4.01-1.29 6.178-5.591 4.884-9.595l-12.078-37.258c-1.301-3.997-5.59-6.182-9.58-4.886l-6.272 2.036a210.447 210.447 0 00-1.721-3.793l5.745-3.325c3.624-2.097 4.877-6.751 2.777-10.388l-19.557-33.94c-2.107-3.638-6.748-4.886-10.385-2.783l-5.813 3.352c-.806-1.113-1.571-2.26-2.391-3.386l4.945-4.458a7.61 7.61 0 00.57-10.741L497.295 82.38a7.6 7.6 0 00-10.73-.563l-4.959 4.485c-1.023-.936-2.066-1.825-3.096-2.748l3.943-5.442a7.636 7.636 0 00-1.68-10.632l-31.65-23.037c-3.4-2.47-8.15-1.716-10.629 1.676l-3.902 5.401c-1.192-.698-2.391-1.377-3.597-2.07l2.71-6.1c1.707-3.84-.027-8.332-3.861-10.042L394.11 17.364c-3.827-1.717-8.326.007-10.033 3.854l-2.682 6.032c-1.315-.434-2.622-.916-3.943-1.33l1.362-6.419c.874-4.105-1.748-8.149-5.847-9.024l-38.281-8.15c-4.099-.882-8.136 1.751-9.01 5.856l-1.362 6.453a434.443 434.443 0 00-4.166-.468V7.613c0-4.2-3.4-7.613-7.594-7.613h-39.122c-4.193 0-7.594 3.413-7.594 7.613v6.568c-1.388.136-2.77.292-4.152.455l-1.362-6.44c-.874-4.111-4.918-6.737-9.01-5.862l-38.275 8.15c-4.098.868-6.72 4.919-5.846 9.024l1.362 6.412c-1.335.414-2.635.896-3.956 1.33l-2.676-6.019c-1.707-3.84-6.199-5.57-10.033-3.86l-35.741 15.938c-3.835 1.71-5.555 6.216-3.848 10.043l2.703 6.1c-1.2.678-2.398 1.37-3.59 2.07l-3.91-5.388c-2.465-3.406-7.22-4.153-10.615-1.69l-31.65 23.037a7.619 7.619 0 00-1.686 10.632l3.95 5.442c-1.03.923-2.087 1.812-3.103 2.748l-4.966-4.478a7.595 7.595 0 00-10.73.563l-26.176 29.13c-2.805 3.114-2.561 7.932.562 10.741l4.952 4.458c-.82 1.127-1.599 2.273-2.398 3.386l-5.806-3.352a7.6 7.6 0 00-10.385 2.782l-19.557 33.94a7.596 7.596 0 002.777 10.39l5.738 3.324a203.649 203.649 0 00-1.72 3.793l-6.267-2.036a7.595 7.595 0 00-9.572 4.886L8.753 221.088c-1.294 3.997.888 8.299 4.884 9.588l6.246 2.036c-.305 1.37-.65 2.714-.935 4.091l-6.455-.699c-4.187-.42-7.92 2.613-8.36 6.786L.041 281.858c-.433 4.194 2.595 7.926 6.768 8.367l6.537.685c-.007.699-.054 1.398-.054 2.09 0 .712.047 1.391.054 2.103l-6.537.679c-4.173.434-7.201 4.18-6.76 8.366l4.084 38.969c.44 4.166 4.173 7.206 8.36 6.758l6.455-.672c.285 1.364.63 2.721.935 4.085l-6.239 2.029a7.62 7.62 0 00-4.884 9.588l12.092 37.265a7.584 7.584 0 009.572 4.886l6.266-2.03a238.334 238.334 0 001.721 3.78l-5.731 3.325a7.618 7.618 0 00-2.784 10.402L49.46 456.46c2.1 3.644 6.747 4.892 10.378 2.782l5.806-3.359c.806 1.127 1.578 2.287 2.405 3.393l-4.946 4.465c-3.13 2.802-3.373 7.62-.569 10.748l26.183 29.116a7.582 7.582 0 0010.73.563l4.953-4.471c1.023.936 2.08 1.832 3.11 2.748l-3.944 5.442c-2.465 3.392-1.713 8.149 1.68 10.625l31.65 23.03a7.587 7.587 0 0010.615-1.676l3.91-5.394c1.185.705 2.39 1.39 3.596 2.083l-2.703 6.086c-1.714 3.834.014 8.333 3.848 10.043l35.735 15.939c3.84 1.71 8.332-.014 10.032-3.854l2.676-6.026c1.328.448 2.629.923 3.957 1.337l-1.355 6.398c-.874 4.112 1.747 8.156 5.846 9.025l38.268 8.15c4.105.881 8.143-1.751 9.017-5.857l1.368-6.439c1.375.156 2.744.326 4.132.468v6.562c0 4.193 3.401 7.613 7.594 7.613h39.122c4.193 0 7.594-3.42 7.594-7.613v-6.562c1.389-.142 2.764-.312 4.14-.468l1.374 6.44c.874 4.111 4.898 6.737 9.01 5.862l38.268-8.15c4.112-.868 6.72-4.912 5.86-9.017l-1.362-6.412c1.321-.414 2.629-.89 3.943-1.337l2.683 6.032c1.707 3.834 6.191 5.571 10.033 3.854l35.734-15.932c3.834-1.71 5.555-6.215 3.848-10.049l-2.696-6.093c1.205-.692 2.405-1.378 3.597-2.083l3.902 5.394a7.611 7.611 0 0010.629 1.683l31.636-23.03a7.596 7.596 0 001.68-10.619l-3.943-5.442c1.043-.93 2.087-1.825 3.11-2.761l4.958 4.478c3.123 2.81 7.926 2.565 10.73-.563l26.184-29.123c2.804-3.115 2.554-7.932-.57-10.748l-4.945-4.451z"></path>
            <path
              id="tos-wheel-hexagon"
              stroke="#288CFF"
              strokeDasharray="1.91 3.819"
              strokeLinejoin="round"
              strokeWidth="1"
              d="M200.681 292.196l46.772-80.48 92.853.328 46.767 80.53-46.767 80.102h-92.741z"></path>
            <g
              className="tos-wheel-screen"
              id="tos-wheel-screens-tenders"
              fill="#001224"
              stroke="#90C4FF"
              transform="translate(73.237 185.92)">
              <path
                id="tos-wheel-little-screen-tenders"
                strokeWidth="0.523"
                d="M.01 23.746l.436 166.39a2.112 2.112 0 003.162 1.827l38.623-22.148a2.112 2.112 0 001.06-1.837l-.31-121.707a2.112 2.112 0 00-1.05-1.82L3.183 21.915A2.112 2.112 0 00.01 23.746z"></path>
              <path
                id="tos-wheel-medium-screen-tenders"
                strokeWidth="0.528"
                d="M8.457 14.247l.486 185.917a2.112 2.112 0 003.165 1.826l43.324-24.905a2.112 2.112 0 001.06-1.837l-.346-135.671a2.112 2.112 0 00-1.048-1.82l-43.465-25.34a2.112 2.112 0 00-3.176 1.83z"></path>
              <path
                id="tos-wheel-big-screen-tenders"
                strokeWidth="1"
                d="M16.905 3.69l.542 207.558a2.112 2.112 0 003.166 1.825L69.16 185.11a2.112 2.112 0 001.058-1.835L69.835 32.13a2.112 2.112 0 00-1.047-1.818L20.082 1.862a2.112 2.112 0 00-3.177 1.829z"></path>
            </g>
            <g
              className="tos-wheel-screen"
              id="tos-wheel-screens-performance-analysis"
              fill="#001224"
              stroke="#288CFF"
              transform="rotate(-60 418.525 139.38)">
              <path
                id="tos-wheel-little-screen-performance-analysis"
                strokeWidth="0.523"
                d="M.01 23.746l.436 166.39a2.112 2.112 0 003.162 1.827l38.623-22.148a2.112 2.112 0 001.06-1.837l-.31-121.707a2.112 2.112 0 00-1.05-1.82L3.183 21.915A2.112 2.112 0 00.01 23.746z"></path>
              <path
                id="tos-wheel-medium-screen-performance-analysis"
                strokeWidth="0.528"
                d="M8.457 14.247l.486 185.917a2.112 2.112 0 003.165 1.826l43.324-24.905a2.112 2.112 0 001.06-1.837l-.346-135.671a2.112 2.112 0 00-1.048-1.82l-43.465-25.34a2.112 2.112 0 00-3.176 1.83z"></path>
              <path
                id="tos-wheel-big-screen-performance-analysis"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M16.905 3.69l.542 207.558a2.112 2.112 0 003.166 1.825L69.16 185.11a2.112 2.112 0 001.058-1.835L69.835 32.13a2.112 2.112 0 00-1.047-1.818L20.082 1.862a2.112 2.112 0 00-3.177 1.829z"></path>
            </g>
            <g
              className="tos-wheel-screen"
              id="tos-wheel-screens-compliance-billing"
              fill="#001224"
              stroke="#90C4FF"
              transform="rotate(-120 312.373 179.377)">
              <path
                id="tos-wheel-little-screen-compliance-billing"
                strokeWidth="0.523"
                d="M.01 23.746l.436 166.39a2.112 2.112 0 003.162 1.827l38.623-22.148a2.112 2.112 0 001.06-1.837l-.31-121.707a2.112 2.112 0 00-1.05-1.82L3.183 21.915A2.112 2.112 0 00.01 23.746z"></path>
              <path
                id="tos-wheel-medium-screen-compliance-billing"
                strokeWidth="0.528"
                d="M8.457 14.247l.486 185.917a2.112 2.112 0 003.165 1.826l43.324-24.905a2.112 2.112 0 001.06-1.837l-.346-135.671a2.112 2.112 0 00-1.048-1.82l-43.465-25.34a2.112 2.112 0 00-3.176 1.83z"></path>
              <path
                id="tos-wheel-big-screen-compliance-billing"
                strokeWidth="1"
                d="M16.905 3.69l.542 207.558a2.112 2.112 0 003.166 1.825L69.16 185.11a2.112 2.112 0 001.058-1.835L69.835 32.13a2.112 2.112 0 00-1.047-1.818L20.082 1.862a2.112 2.112 0 00-3.177 1.829z"></path>
            </g>
            <g
              className="tos-wheel-screen"
              id="tos-wheel-screens-follow-operations"
              fill="#001224"
              stroke="#288CFF"
              transform="rotate(-180 257.581 200.406)">
              <path
                id="tos-wheel-little-screen-follow-operations"
                strokeWidth="0.523"
                d="M.01 23.746l.436 166.39a2.112 2.112 0 003.162 1.827l38.623-22.148a2.112 2.112 0 001.06-1.837l-.31-121.707a2.112 2.112 0 00-1.05-1.82L3.183 21.915A2.112 2.112 0 00.01 23.746z"></path>
              <path
                id="tos-wheel-medium-screen-follow-operations"
                strokeWidth="0.528"
                d="M8.457 14.247l.486 185.917a2.112 2.112 0 003.165 1.826l43.324-24.905a2.112 2.112 0 001.06-1.837l-.346-135.671a2.112 2.112 0 00-1.048-1.82l-43.465-25.34a2.112 2.112 0 00-3.176 1.83z"></path>
              <path
                id="tos-wheel-big-screen-follow-operations"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M16.905 3.69l.542 207.558a2.112 2.112 0 003.166 1.825L69.16 185.11a2.112 2.112 0 001.058-1.835L69.835 32.13a2.112 2.112 0 00-1.047-1.818L20.082 1.862a2.112 2.112 0 00-3.177 1.829z"></path>
            </g>
            <g
              className="tos-wheel-screen"
              id="tos-wheel-screens-territory"
              fill="#001224"
              stroke="#90C4FF"
              transform="rotate(120 205.184 221.17)">
              <path
                id="tos-wheel-little-screen-territory"
                strokeWidth="0.523"
                d="M.01 23.746l.436 166.39a2.112 2.112 0 003.162 1.827l38.623-22.148a2.112 2.112 0 001.06-1.837l-.31-121.707a2.112 2.112 0 00-1.05-1.82L3.183 21.915A2.112 2.112 0 00.01 23.746z"></path>
              <path
                id="tos-wheel-medium-screen-territory"
                strokeWidth="0.528"
                d="M8.457 14.247l.486 185.917a2.112 2.112 0 003.165 1.826l43.324-24.905a2.112 2.112 0 001.06-1.837l-.346-135.671a2.112 2.112 0 00-1.048-1.82l-43.465-25.34a2.112 2.112 0 00-3.176 1.83z"></path>
              <path
                id="tos-wheel-big-screen-territory"
                strokeWidth="1"
                d="M16.905 3.69l.542 207.558a2.112 2.112 0 003.166 1.825L69.16 185.11a2.112 2.112 0 001.058-1.835L69.835 32.13a2.112 2.112 0 00-1.047-1.818L20.082 1.862a2.112 2.112 0 00-3.177 1.829z"></path>
            </g>
            <g
              className="tos-wheel-screen"
              id="tos-wheel-screens-fleet-depots"
              fill="#001224"
              stroke="#288CFF"
              transform="rotate(60 95.129 262.224)">
              <path
                id="tos-wheel-little-screen-fleet-depots"
                strokeWidth="0.523"
                d="M.01 23.746l.436 166.39a2.112 2.112 0 003.162 1.827l38.623-22.148a2.112 2.112 0 001.06-1.837l-.31-121.707a2.112 2.112 0 00-1.05-1.82L3.183 21.915A2.112 2.112 0 00.01 23.746z"></path>
              <path
                id="tos-wheel-medium-screen-fleet-depots"
                strokeWidth="0.528"
                d="M8.457 14.247l.486 185.917a2.112 2.112 0 003.165 1.826l43.324-24.905a2.112 2.112 0 001.06-1.837l-.346-135.671a2.112 2.112 0 00-1.048-1.82l-43.465-25.34a2.112 2.112 0 00-3.176 1.83z"></path>
              <path
                id="tos-wheel-big-screen-fleet-depots"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M16.905 3.69l.542 207.558a2.112 2.112 0 003.166 1.825L69.16 185.11a2.112 2.112 0 001.058-1.835L69.835 32.13a2.112 2.112 0 00-1.047-1.818L20.082 1.862a2.112 2.112 0 00-3.177 1.829z"></path>
            </g>
            <path
              className="tos-wheel-connector"
              id="tos-wheel-connector-territory"
              stroke="#EBEBEB"
              strokeWidth="1"
              d="M340.135 211.528l41.711-72.334"></path>
            <path
              className="tos-wheel-connector"
              id="tos-wheel-connector-compliance-billing"
              stroke="#EBEBEB"
              strokeWidth="1"
              d="M340.135 372.564l43.823 73.918"></path>
            <path
              className="tos-wheel-connector"
              id="tos-wheel-connector-performance-analysis"
              stroke="#EBEBEB"
              strokeWidth="1"
              d="M247.209 372.564l-43.295 73.918"></path>
            <path
              className="tos-wheel-connector"
              id="tos-wheel-connector-tenders"
              stroke="#EBEBEB"
              strokeWidth="1"
              d="M200.746 292.31h-84.478"></path>
            <path
              className="tos-wheel-connector"
              id="tos-wheel-connector-fleet-depots"
              stroke="#FFF"
              strokeWidth="1"
              d="M204.97 139.194l42.239 72.334"></path>
            <path
              className="tos-wheel-connector"
              id="tos-wheel-connector-follow-operations"
              stroke="#EBEBEB"
              strokeWidth="1"
              d="M471.604 292.31h-84.478"></path>
            <circle
              className="tos-wheel-inner-dot"
              id="tos-wheel-inner-dot-territory"
              cx="340.399"
              cy="211.792"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-inner-dot"
              id="tos-wheel-inner-dot-compliance-billing"
              cx="340.399"
              cy="372.828"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-inner-dot"
              id="tos-wheel-inner-dot-performance-analysis"
              cx="247.473"
              cy="372.828"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-inner-dot"
              id="tos-wheel-inner-dot-fleet-depots"
              cx="247.473"
              cy="211.792"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-inner-dot"
              id="tos-wheel-inner-dot-tenders"
              cx="200.482"
              cy="292.574"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-inner-dot"
              id="tos-wheel-inner-dot-follow-operations"
              cx="386.862"
              cy="292.574"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-dot"
              id="tos-wheel-dot-tenders"
              cx="116.532"
              cy="292.574"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-dot"
              id="tos-wheel-dot-performance-analysis"
              cx="204.178"
              cy="446.746"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-dot"
              id="tos-wheel-dot-compliance-billing"
              cx="384.222"
              cy="446.746"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-dot"
              id="tos-wheel-dot-follow-operations"
              cx="471.34"
              cy="292.574"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-dot"
              id="tos-wheel-dot-territory"
              cx="382.11"
              cy="139.458"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
            <circle
              className="tos-wheel-dot"
              id="tos-wheel-dot-fleet-depots"
              cx="205.234"
              cy="139.458"
              r="9.549"
              fill="#001224"
              stroke="#288CFF"
              strokeLinejoin="round"
              strokeWidth="1"></circle>
          </g>
          <g
            id="tos-wheel-label-lines"
            stroke="#EBEBEB"
            strokeWidth="1"
            transform="translate(.004 59.476)">
            <path
              className="tos-wheel-label-line"
              id="tos-wheel-label-line-territory"
              d="M387.122 71.579L427.898 0h158.098"></path>
            <path
              className="tos-wheel-label-line"
              id="tos-wheel-label-line-compliance-billing"
              d="M387.122 396l40.776 71.579h158.098"></path>
            <path
              className="tos-wheel-label-line"
              id="tos-wheel-label-line-performance-analysis"
              d="M198.996 396l-40.777 71.579H.122"></path>
            <path
              className="tos-wheel-label-line"
              id="tos-wheel-label-line-fleet-depots"
              d="M198.996 71.579L158.219 0H.122"></path>
            <path
              className="tos-wheel-label-line"
              id="tos-wheel-label-line-tenders"
              d="M106.486 233.024H.505"></path>
            <path
              className="tos-wheel-label-line"
              id="tos-wheel-label-line-follow-operations"
              fill="#001224"
              d="M587.486 233.024H481.505"></path>
          </g>
        </g>
      </svg>
      <span id="tos-wheel-label-fleet-depots" className="tos-wheel-label">
        {t("transport-operating-system.wheel.fleet-depots")}
      </span>
      <span id="tos-wheel-label-territory" className="tos-wheel-label">
        {t("transport-operating-system.wheel.territory")}
      </span>
      <span id="tos-wheel-label-follow-operations" className="tos-wheel-label">
        {t("transport-operating-system.wheel.follow-operations")}
      </span>
      <span id="tos-wheel-label-compliance-billing" className="tos-wheel-label">
        {t("transport-operating-system.wheel.compliance-billing")}
      </span>
      <span id="tos-wheel-label-performance-analysis" className="tos-wheel-label">
        {t("transport-operating-system.wheel.performance-analysis")}
      </span>
      <span id="tos-wheel-label-tenders" className="tos-wheel-label">
        {t("transport-operating-system.wheel.tenders")}
      </span>
      <button className="tos-animation-restart" onClick={() => restartAnimation()}>
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 6a1 1 0 110-2h3a8 8 0 11-8 8H1l4-5 4 5H6a6 6 0 106-6H9z"
            fill="currentColor"
          />
        </svg>
        {t("transport-operating-system.wheel.replay")}
      </button>
    </div>
  );
}
